'use strict';
(function() {
	angular
		.module('onboarding.common')
		.directive('cobAddress', cobAddress);

	cobAddress.$inject = ['subjectObserverMessagesService', 'observerService', 'validationService'];
	var subjectObserverMessagesService, observerService, subjectMessages, observerMessages, validationService;

	function cobAddress(_subjectObserverMessagesService_, _observerService_, _validationService_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		validationService = _validationService_;

		return {
			restrict: 'E',
			scope: {
				hide: '=',
				readOnly: '=',
				address: '=',
				isValid: '='
			},
			templateUrl: '/app/common/directives/cobAddress.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.setIsDirty = setIsDirty;
			scope.validateStreet = validateStreet;
			scope.validateCity = validateCity;
			scope.validateStateProvince = validateStateProvince;
			scope.validatePostalCode = validatePostalCode;
			scope.validatePhoneNumber = validatePhoneNumber;
			scope.validatePhoneExt = validatePhoneExt;

			scope.m = {
            
			};

			scope.stateList = [
				{ key: 'AL', value: 'AL', country: 'USA' },
				{ key: 'AK', value: 'AK', country: 'USA' },
				{ key: 'AS', value: 'AS', country: 'USA' },
				{ key: 'AZ', value: 'AZ', country: 'USA' },
				{ key: 'AR', value: 'AR', country: 'USA' },
				{ key: 'CA', value: 'CA', country: 'USA' },
				{ key: 'CO', value: 'CO', country: 'USA' },
				{ key: 'CT', value: 'CT', country: 'USA' },
				{ key: 'DE', value: 'DE', country: 'USA' },
				{ key: 'DC', value: 'DC', country: 'USA' },
				{ key: 'FL', value: 'FL', country: 'USA' },
				{ key: 'GA', value: 'GA', country: 'USA' },
				{ key: 'GU', value: 'GU', country: 'USA' },
				{ key: 'HI', value: 'HI', country: 'USA' },
				{ key: 'ID', value: 'ID', country: 'USA' },
				{ key: 'IL', value: 'IL', country: 'USA' },
				{ key: 'IN', value: 'IN', country: 'USA' },
				{ key: 'IA', value: 'IA', country: 'USA' },
				{ key: 'KS', value: 'KS', country: 'USA' },
				{ key: 'KY', value: 'KY', country: 'USA' },
				{ key: 'LA', value: 'LA', country: 'USA' },
				{ key: 'ME', value: 'ME', country: 'USA' },
				{ key: 'MD', value: 'MD', country: 'USA' },
				{ key: 'MA', value: 'MA', country: 'USA' },
				{ key: 'MI', value: 'MI', country: 'USA' },
				{ key: 'MN', value: 'MN', country: 'USA' },
				{ key: 'MS', value: 'MS', country: 'USA' },
				{ key: 'MO', value: 'MO', country: 'USA' },
				{ key: 'MT', value: 'MT', country: 'USA' },
				{ key: 'NE', value: 'NE', country: 'USA' },
				{ key: 'NV', value: 'NV', country: 'USA' },
				{ key: 'NH', value: 'NH', country: 'USA' },
				{ key: 'NJ', value: 'NJ', country: 'USA' },
				{ key: 'NM', value: 'NM', country: 'USA' },
				{ key: 'NY', value: 'NY', country: 'USA' },
				{ key: 'NC', value: 'NC', country: 'USA' },
				{ key: 'ND', value: 'ND', country: 'USA' },
				{ key: 'OH', value: 'OH', country: 'USA' },
				{ key: 'OK', value: 'OK', country: 'USA' },
				{ key: 'OR', value: 'OR', country: 'USA' },
				{ key: 'PA', value: 'PA', country: 'USA' },
				{ key: 'PR', value: 'PR', country: 'USA' },
				{ key: 'RI', value: 'RI', country: 'USA' },
				{ key: 'SC', value: 'SC', country: 'USA' },
				{ key: 'SD', value: 'SD', country: 'USA' },
				{ key: 'TN', value: 'TN', country: 'USA' },
				{ key: 'TX', value: 'TX', country: 'USA' },
				{ key: 'UT', value: 'UT', country: 'USA' },
				{ key: 'VT', value: 'VT', country: 'USA' },
				{ key: 'VA', value: 'VA', country: 'USA' },
				{ key: 'VI', value: 'VI', country: 'USA' },
				{ key: 'WA', value: 'WA', country: 'USA' },
				{ key: 'WV', value: 'WV', country: 'USA' },
				{ key: 'WI', value: 'WI', country: 'USA' },
				{ key: 'WY', value: 'WY', country: 'USA' },
				{ key: 'AB', value: 'AB', country: 'Canada' },
				{ key: 'BC', value: 'BC', country: 'Canada' },
				{ key: 'MB', value: 'MB', country: 'Canada' },
				{ key: 'NB', value: 'NB', country: 'Canada' },
				{ key: 'NF', value: 'NF', country: 'Canada' },
				{ key: 'NT', value: 'NT', country: 'Canada' },
				{ key: 'NS', value: 'NS', country: 'Canada' },
				{ key: 'NU', value: 'NU', country: 'Canada' },
				{ key: 'ON', value: 'ON', country: 'Canada' },
				{ key: 'PE', value: 'PE', country: 'Canada' },
				{ key: 'PQ', value: 'PQ', country: 'Canada' },
				{ key: 'SK', value: 'SK', country: 'Canada' },
				{ key: 'YT', value: 'YT', country: 'Canada' }
			];

			scope.$watch('isValid',
				function(newVal) {
					if (newVal === null)
						scope.isValid = isValid();
				});

			scope.$watch('address',
				function(newVal) {
					if (newVal) {
						if (Object.keys(newVal).length === 0)
							scope.m = {
                        
							};
					} else {
						newVal = {};
					}
				});
		}

		function isValid() {
			validateStreet();
			validateCity();
			validateStateProvince();
			validatePostalCode();
			validatePhoneNumber();
			validatePhoneExt();


			if (scope.m.streetError)
				return false;
			if (scope.m.cityError)
				return false;
			if (scope.m.stateProvinceError)
				return false;
			if (scope.m.postalCodeError)
				return false;
			if (scope.m.phoneNumberError)
				return false;
			if (scope.m.phoneExtError)
				return false;

			return true;
		}

		function setIsDirty() {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_IS_DIRTY);
		}

		function validateStreet() {
			if (!scope.address.street) {
				scope.m.streetError = 'Valid input is required.';
			} else {
				scope.m.streetError = '';
			}
		}

		function validateCity() {
			if (!scope.address.city) {
				scope.m.cityError = 'Valid input is required.';
			} else {
				scope.m.cityError = '';
			}
		}

		function validateStateProvince() {
			if (!scope.address.stateProvince) {
				scope.m.stateProvinceError = 'Valid input is required.';
			} else {
				scope.m.stateProvinceError = '';
			}
		}

		function validatePostalCode() {
			if (!scope.address.postalCode || scope.address.postalCode.length === 0) {
				scope.m.postalCodeError = 'Valid input is required';
			} else if (validationService.isValidUsPostalCode(scope.address.postalCode)) {
				scope.m.postalCodeError = '';
				scope.address.countryCode = 'us';
			}
			else if (validationService.isValidCanadianPostalCode(scope.address.postalCode)) {
				scope.m.postalCodeError = '';
				scope.address.countryCode = 'ca';
			} else {
				scope.m.postalCodeError = 'Valid input is required';
			}
		}

		function validatePhoneNumber() {
			if (!scope.address.phoneNumber) {
				scope.m.phoneNumberError = 'Input is required';
			} else if (scope.address.phoneNumber.length !== 10) {
				scope.m.phoneNumberError = 'Valid input is required';
			} else if (scope.address.phoneNumber[0] === '0' || scope.address.phoneNumber[0] === '1') {
				scope.m.phoneNumberError = 'Valid input is required';
			} else {
				scope.m.phoneNumberError = '';
			}
		}

		function validatePhoneExt() {
			if (/^[0-9]{0,5}$/.test(scope.address.phoneExt) || !scope.address.phoneExt) {
				scope.m.phoneExtError = '';
			} else {
				scope.m.phoneExtError = 'Valid input is required';
			}
		}
	}
})();
